import React, { useState, useEffect, Fragment } from "react";
import {
  Row,
  Col,
  CardBody,
  Label,
  Card,
  Input,
  FormFeedback
} from "reactstrap";
import Select from "react-select";
import i18n from "../../../i18n";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getOrgsAdmin } from "../../../helpers/api_rombo_helper";
import PropTypes from "prop-types";

const Step1 = ({ step, setStep, token, setIdentifier, setName, setDepot, setEmail, setPhone, setCompany, identifier, name, depot, email, phone, company, infoUser, setErrorAlert, setErrorAlertMessage }) => {

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [emailValid, setEmailValid] = useState(false);
  const [phoneValid, setPhoneValid] = useState(false);
  const [listCompanies, setListCompanies] = useState([]);
  const [isCompanyDisabled, setIsCompanyDisabled] = useState(false);

  useEffect(() => {
    onGetOrgsAdmin();
    fillCompany();
  }, [dispatch]);
  
  useEffect(() => {
    onGetOrgsAdmin();
    
    const savedCompany = sessionStorage.getItem('selectedCompany');
    if (savedCompany) {
      const companyData = JSON.parse(savedCompany);
      setIsCompanyDisabled(true);
      
      setCompany({
        value: companyData.value,
        label: companyData.label
      });
      
      sessionStorage.removeItem('selectedCompany');
    } else {
      fillCompany();
    }
  }, [dispatch]);
  
  const fillCompany = () => {
    if (!infoUser.is_staff && infoUser.partner_name && infoUser.partner_id) {
      setCompany({ label: infoUser.partner_name, value: infoUser.partner_id });
    }
  };   

  const onGetOrgsAdmin = () => {
    let partnersInfo = [];
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          partnersInfo.push({ label: item.name, value: item.partner_id || item.id });
        });
        setListCompanies([...partnersInfo]);
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message));
      });
  };

  const onClickNextStep = () => {
    if(name && email && phone){
      setErrorAlertMessage(null);
      setErrorAlert(false);
      setStep(step + 1);
    } else {
      setErrorAlertMessage(i18n.t("PleaseFillAllFields"));
      setErrorAlert(true);
    }
  };

  const onBlurPhone = (newPhone) => {
    if (!(newPhone.match('[0-9]{10}'))) {
      setPhoneValid(true);
    } else {
      setPhoneValid(false);
      setPhone(newPhone);
    }
  };
  
  const onBlurEmail = (newEmail) => {
    if (!(newEmail.match(/.+@.+\..+/))) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
      setEmail(newEmail);
    }
  };

  const handleGoBack = () => {
    const comeFromRequestCreate = location.state?.from === '/request/create';
    const hasHistory = window.history.length > 1;
    
    if (comeFromRequestCreate) {
      navigate('/request/create');
    } else if (hasHistory) {
      navigate(-1);
    } else {
      navigate('/employees');
    }
  };

  return (
    <Fragment>
      <CardBody>
        <Row>
          {infoUser.is_staff && (
            <Col xxl={6} md={6} xs={12}>
              <h6 className="employees-form-title" htmlFor="companyNameInput">
                {i18n.t("Partner")}
              </h6>
              <p className="employees-form-text">{i18n.t("DescSelectPartner")}</p>
              <Card className="mb-3">
                <Select
                  name="company"
                  placeholder={i18n.t("SelectPartnerName")}
                  options={listCompanies}
                  className="select2-selection"
                  value={company}
                  onChange={(selectedOption) => {
                    setCompany(selectedOption);
                  }}
                  isDisabled={isCompanyDisabled}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      backgroundColor: isCompanyDisabled ? '#f8f9fa' : 'white',
                      cursor: isCompanyDisabled ? 'not-allowed' : 'default'
                    })
                  }}
                />
              </Card>
              {isCompanyDisabled && (
                <Card className="mt-2 preselected-message-card">
                  <div className="preselected-info">
                    <i className="bx bx-task" /> {i18n.t("CompanyPreselectedFromRequest")}
                  </div>
                </Card>
              )}
              <div className="request-separator" />
            </Col>
          )}
          <Col xs={12} xxl={12} xl={12} className="pb-3">
            <h6 className="employees-form-title">{i18n.t("DataEmployee")}</h6>
            <span className="employees-form-text">{i18n.t("DescEmployee")}</span>
          </Col>
          <Col xs={12} xxl={6} xl={6} className="row">
            <Col xs={12} xxl={12} xl={12} className="">
              <Label className="employees-form-subtitle" htmlFor="nameInput">
                {i18n.t("EmployeeNumber")}
              </Label>
              <Input
                type="text"
                name="identifier"
                value={identifier}
                className="employees-form-input"
                id="identifierInput"
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setIdentifier(value);
                  }
                }}
                placeholder={i18n.t("EmployeeNumber")}
              />
              <Label className="employees-form-subtitle" htmlFor="nameInput">
                {i18n.t("DisplayName")}
              </Label>
              <Input
                type="text"
                name="name"
                value={name}
                className="employees-form-input"
                id="nameInput"
                onChange={(e) => setName(e.target.value)}
                placeholder={i18n.t("EmployeeName")}
              />
              <Label className="employees-form-subtitle" htmlFor="nameInput">
                {i18n.t("Department")}
              </Label>
              <Input
                type="text"
                name="depot"
                value={depot}
                className="employees-form-input"
                id="depotInput"
                onChange={(e) => setDepot(e.target.value)}
                placeholder={i18n.t("EmployeeDepartment")}
              />
            </Col>
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="emailInput">
                {i18n.t("Email")}
              </Label>  
              <Input
                type="email"
                name="email"
                defaultValue={email}
                className="employees-form-input"
                id="emailInput"
                onBlur={(e) => onBlurEmail(e.target.value)}
                placeholder={i18n.t("Email")}
              />
              {emailValid && (
                <FormFeedback type="invalid" className="error-message">
                  <i className="fa fa-exclamation-circle" />
                  {i18n.t("EmailInvalid")}
                </FormFeedback>
              )}
            </Col>
            <Col xs={12} xxl={6} xl={6} className="">
              <Label className="employees-form-subtitle" htmlFor="phoneInput">
                {i18n.t("Phone")}
              </Label>  
              <Input
                type="text"
                name="phone"
                defaultValue={phone}
                className="employees-form-input"
                id="phoneInput"
                minLength={10}
                maxLength={10}
                onBlur={(e) => onBlurPhone(e.target.value)}
                placeholder={i18n.t("EmployeePhone")}
              />
              {phoneValid && (
                <FormFeedback type="invalid" className="error-message">
                  <i className="fa fa-exclamation-circle" />
                  {i18n.t("PhoneInvalid")}
                </FormFeedback>
              )}
            </Col>
            <Col xxl={12} md={12} xs={12}>
              <div className="request-separator" />
            </Col>
          </Col>
          <Col xxl={12} md={12} xs={12} className="pt-2 d-flex">
            <button onClick={() => onClickNextStep()} className="btn btn-request">
              {i18n.t("NextStep")}
            </button>
            <button onClick={handleGoBack} className="btn btn-go-back mx-2">
              {i18n.t("GoBack")}
            </button>
          </Col>
        </Row>
      </CardBody>
    </Fragment>
  );
};

Step1.propTypes = {
  step: PropTypes.number.isRequired,
  setStep: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  setPhone: PropTypes.func.isRequired,
  setCompany: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  company: PropTypes.object.isRequired,
  infoUser: PropTypes.object.isRequired,
  setErrorAlert: PropTypes.func.isRequired,
  setErrorAlertMessage: PropTypes.func.isRequired,
};

export default Step1;
